import type { AxiosError, AxiosInstance } from 'axios'
import type { FeedbackUpdateReceipt } from '../../api/stakeholderEngagement'

export const createEditionApi = (apiClient: AxiosInstance) => ({
  base: {
    billing: {
      getSubscription: () => apiClient.get('/api/v1/billing/subscription'),
      checkout: (data: { planCode: string; stripePriceId?: string; customerEmail: string; successUrl: string; cancelUrl: string }) =>
        apiClient.post('/api/v1/billing/checkout', data),
    },

    signup: {
      createWorkspace: (data: {
        organizationName: string
        tenantIdentifier?: string
        adminEmail: string
        adminFirstName?: string
        adminLastName?: string
        adminPassword: string
        planCode: string
        successUrl: string
        cancelUrl: string
      }) => apiClient.post('/api/v1/signup/workspaces', data),
    },
  },
  users: {
    changePassword: (data: { currentPassword: string; newPassword: string }) =>
      apiClient.post('/api/v1/users/me/password', data),
    resetPassword: (id: string) =>
      apiClient.post<{ temporaryPassword: string }>(`/api/v1/users/${id}/password-reset`),
  },
  stakeholder: {
    feedbackUpdate: (notificationId: string) =>
      apiClient.get<FeedbackUpdateReceipt>(`/api/v1/notifications/${notificationId}/feedback-update`),
  },
})

export function handleEditionError(error: AxiosError) {
  const responseData = error.response?.data as { code?: string } | undefined
  if (error.response?.status === 402 && responseData?.code === 'TRIAL_EXPIRED') {
    if (window.location.pathname !== '/trial-expired') {
      window.location.href = '/trial-expired'
    }
  }
}
